import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Captions are STICKY: each line holds until the next begins. Lines are ~5.5-6s apart.
//
// GROUNDING (every claim → a real file:line in EAKC-MVP):
//   graph_query tool, Zod 3-500 chars, isError:false fallback, tenant isolation,
//     markdown + [Source N], two-block content ........ src/lib/mcp/tools.ts:73,348-354,448-453
//   ops whoCalls/pathBetween/dependents/impactRadius/mostConnected . src/lib/graph/bypass-handler.ts:646-691
//   in-memory adjacency list rebuilt from document_chunks.metadata_graph jsonb (entities+relationships),
//     tenant-scoped ............................. src/lib/graph/graph-store.ts:1-17,469-564
//   metadata_graph JSONB column ............... supabase/migrations/001_initial_schema.sql:65
//   classifier = regex-first heuristic, LLM fallback only when confidence <0.7 . src/lib/graph/classifier.ts:69-188,330-389
//   NL→DSL translator is deterministic pattern-matching, no LLM . src/lib/graph/nl-translator.ts:1-21
//   answer = no LLM, deterministic markdown, p95 <4s ... src/lib/graph/answer-formatter.ts:10-11 ; bypass-handler.ts:571

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.4, holdSec: 5.5, caption: "Ask vector search “who calls this function?” and it returns chunks that merely look related." },
  { scene: "hook", fromSec: 6.2, holdSec: 5.5, caption: "Cosine similarity can’t answer a structural question. So I gave my RAG a graph it can traverse." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "“Who calls X”, “path from A to B”, “blast radius of this change” — these are edges, not embeddings." },
  { scene: "problem", fromSec: 6.2, holdSec: 6, caption: "Top-k by meaning gives you neighbours in vector space, not callers in the call graph." },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.4, holdSec: 5.5, caption: "At ingest, each chunk already stores entities and relationships in a metadata_graph JSON column." },
  { scene: "intuition", fromSec: 6.2, holdSec: 6, caption: "Walk those edges and “who calls X” becomes a reverse-BFS — a traversal, not a similarity sort." },
];

export const APPROACH: ScriptLine[] = [
  { scene: "approach", fromSec: 0.4, holdSec: 6, caption: "The pipeline: classify the query, translate it to a traversal op, walk the graph, render cited markdown." },
  { scene: "approach", fromSec: 6.6, holdSec: 6, caption: "The classifier is regex-first — a keyword heuristic — with an LLM fallback only when it’s unsure." },
  { scene: "approach", fromSec: 13, holdSec: 5.5, caption: "The NL→DSL translator is pure pattern-matching. No LLM picks the op." },
];

export const TOOL: ScriptLine[] = [
  { scene: "tool", fromSec: 0.5, holdSec: 6, caption: "graph_query exposes five ops: whoCalls, pathBetween, dependents, impactRadius, mostConnected." },
  { scene: "tool", fromSec: 6.7, holdSec: 6, caption: "It runs over the tenant’s graph only — isolation is threaded through the build, never cross-tenant." },
  { scene: "tool", fromSec: 13, holdSec: 5.5, caption: "Returns compact markdown with inline [Source N] citations, plus a JSON block of nodes and edges." },
];

export const HONESTY: ScriptLine[] = [
  { scene: "honesty", fromSec: 0.4, holdSec: 6, caption: "Honest scope: this graph is NOT a separate graph database. Apache AGE was rejected." },
  { scene: "honesty", fromSec: 6.6, holdSec: 6, caption: "It’s an in-memory adjacency list rebuilt on demand from the metadata_graph jsonb column." },
  { scene: "honesty", fromSec: 13, holdSec: 5.5, caption: "And when a query isn’t graph-shaped, it returns isError:false and falls back to normal RAG." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 5.5, caption: "The traversal + answer path runs no LLM — one walk, one string assembly. Deterministic." },
  { scene: "payoff", fromSec: 6.2, holdSec: 5.5, caption: "That keeps the in-code target at p95 under four seconds on graph-shaped queries." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5.5, caption: "Vector search finds what’s similar. A graph answers what’s connected. A real RAG needs both." },
  { scene: "outro", fromSec: 6, holdSec: 4, caption: "Next: the one function that exports everything I know about a user." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
